import api from './api';

export const getAllCounsellors = async () => {
  const response = await api.get('/counsellors/');
  return response.data;
};

export const getCounsellorById = async (counsellorId) => {
  const response = await api.get(`/counsellors/${counsellorId}`);
  return response.data;
};

export const getMyCounsellorProfile = async () => {
  const response = await api.get('/counsellors/me');
  return response.data;
};

export const createSelfAccount = async (counsellorData) => {
  const response = await api.post('/counsellors/create_self', counsellorData);
  return response.data;
};

export const getMyCounsellorProjects = async () => {
  const response = await api.get('/counsellors/me/projects');
  return response.data;
};

export const createCounsellor = async (counsellorData) => {
  const response = await api.post('/counsellors/', counsellorData);
  return response.data;
};

export const updateCounsellor = async (counsellorId, counsellorData) => {
  const response = await api.put(`/counsellors/${counsellorId}`, counsellorData);
  return response.data;
};

export const deleteCounsellor = async (counsellorId) => {
  const response = await api.delete(`/counsellors/${counsellorId}`);
  return response.data;
};

export const assignCounsellorToProject = async (projectId, counsellorId) => {
  const response = await api.post('/counsellors/assign-to-project', null, {
    params: { project_id: projectId, counsellor_id: counsellorId }
  });
  return response.data;
};

export const removeCounsellorFromProject = async (projectId, counsellorId) => {
  const response = await api.delete('/counsellors/remove-from-project', {
    params: { project_id: projectId, counsellor_id: counsellorId }
  });
  return response.data;
};

export const suspendCounsellor = async (userId, reason = null) => {
  const response = await api.post(`/auth/suspend-user/${userId}`, null, {
    params: { reason }
  });
  return response.data;
};

export const unsuspendCounsellor = async (userId) => {
  const response = await api.post(`/auth/unsuspend-user/${userId}`);
  return response.data;
};

